angular.module('Directives')
.directive('exposuresList', exposuresList)

function exposuresList($templateCache) {
	return {
		restrict: 'E',
		scope: {
			statistics: '=statistics',
		},
		bindToController: true,
		controller: function(){},
		controllerAs: 'vm',
		template: $templateCache.get('exposuresList.tpl.html'),
		link: function($scope, iElm, iAttrs, controller) {}
	};
}